import {crmsData} from '../../components/integrations/crmsData.js';

export function getCommercialName(name) {
  const data = crmsData().find(c => c.name === name);
  return data ? data.commercialName : null;
}
